// Test IDs for the home / landing feature. kebab-case `<feature>-<element>`.

export const HOME = {
  emergentLink: "home-emergent-link",

  // Navigation
  navLogo: "nav-logo",
  navFeatures: "nav-features-link",
  navPricing: "nav-pricing-link",
  navChangelog: "nav-changelog-link",
  navDocs: "nav-docs-link",
  navSignIn: "nav-sign-in-btn",
  navGetStarted: "nav-get-started-btn",
  navThemeToggle: "nav-theme-toggle-btn",
  navMobileMenuBtn: "nav-mobile-menu-btn",

  // Hero
  heroBadge: "hero-badge",
  heroTitle: "hero-title",
  heroSubtitle: "hero-subtitle",
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  heroPreview: "hero-preview",

  // Marketplaces strip
  marketplacesStrip: "marketplaces-strip",

  // Features
  featuresSection: "features-section",
  featureCard: (slug) => `feature-card-${slug}`,

  // How it works
  howItWorks: "how-it-works-section",
  howStep: (i) => `how-step-${i}`,

  // Pricing
  pricingSection: "pricing-section",
  pricingCard: (tier) => `pricing-card-${tier}`,
  pricingCta: (tier) => `pricing-cta-${tier}`,

  // FAQ
  faqSection: "faq-section",
  faqItem: (i) => `faq-item-${i}`,

  // Final CTA
  finalCta: "final-cta-section",
  finalCtaButton: "final-cta-button",

  // Footer
  footer: "site-footer",
  footerLink: (slug) => `footer-link-${slug}`,
};
